import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Message, SpinnerService, UtilsService } from "shared-components";
import { AdminContextService } from "../../context/admin-contex.service";
import { AdminService } from "../../services/admin.service";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-csv-logs",
  templateUrl: "./csv-logs.component.html",
})
export class CsvLogsComponent implements OnInit, OnDestroy {
  private _filters;
  public filtersForm: UntypedFormGroup;
  public filtersVisible = false;

  public csvLogs;
  public csvFileName: string | null = null;
  public csvTypeId: number | null = null;
  public csvTypes: Array<any> = [];

  public mensajes = new Array<Message>();
  public showError: boolean;

  public dropdownSection: number;
  public pestanaActiva = new Array<number>();

  private readonly _DEFAULT_ITEMS_PER_PAGE = 10;
  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 0;
  public totalItems: number;
  public readonly visiblePages = 3;

  public toCloseSpinner = 0;

  public orderBy: string;
  public columnId: number;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private _fb: UntypedFormBuilder,
    private readonly _spinnerService: SpinnerService,
    private readonly _sessionContext: SessionContextService,
    private readonly _adminContext: AdminContextService,
    private readonly _adminService: AdminService,
    private readonly utilsService: UtilsService,
    private readonly _translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.filtersForm = this._fb.group({
      userName: [""],
      csvType: [""],
      minRec: ["", Validators.pattern(/^[0-9]*$/)],
      maxRec: ["", Validators.pattern(/^[0-9]*$/)],
      insertedUpdatedOrInvalid: ["insercion"],
      fechaInicio: [""],
      fechaFin: [""],
    });

    this.csvTypes = this._adminService.getCsvTypes();

    this.filtersForm
      .get("fechaInicio")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.validDates());
    this.filtersForm
      .get("fechaFin")
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.validDates());

    this.getCsvLogs();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public get isSmallScreen() {
    return this._sessionContext.isSmallScreen();
  }

  public validDates() {
    if (
      this.filtersForm.get("fechaInicio").value &&
      this.filtersForm.get("fechaFin").value
    ) {
      if (
        this.checkDates(
          this.filtersForm.get("fechaInicio").value,
          this.filtersForm.get("fechaFin").value
        )
      ) {
        this.clearDatesValidators();
      } else {
        this.filtersForm.get("fechaInicio").setErrors(["Invalid date"]);
        this.filtersForm.get("fechaFin").setErrors(["Invalid date"]);
      }
      if (
        this.filtersForm.get("fechaInicio").invalid ||
        this.filtersForm.get("fechaFin").invalid
      ) {
        this.showError = true;
        this.mensajes.push({
          class: "error",
          message: "global.fecha.error.finAnteriorInicio",
        });
      } else {
        this.showError = false;
        this.mensajes = [];
      }
    } else {
      this.clearDatesValidators();
      this.showError = false;
      this.mensajes = [];
    }
  }

  private clearDatesValidators() {
    if (
      this.filtersForm.get("fechaFin").errors &&
      this.filtersForm.get("fechaFin").value
    ) {
      this.filtersForm.get("fechaFin").clearValidators();
      this.filtersForm.get("fechaFin").updateValueAndValidity();
    }
    if (
      this.filtersForm.get("fechaInicio").errors &&
      this.filtersForm.get("fechaInicio").value
    ) {
      this.filtersForm.get("fechaInicio").clearValidators();
      this.filtersForm.get("fechaInicio").updateValueAndValidity();
    }
  }

  private checkDates(inicio, fin) {
    const inicioD = new Date(inicio);
    const finD = new Date(fin);
    return inicioD <= finD;
  }

  public handleRadioDates(event) {
    const value = event.currentTarget.value;
    this.filtersForm.get("insertedUpdatedOrInvalid").setValue(value);
  }

  public checkValuesForm(): boolean {
    return this.filtersForm.get("fechaInicio").value ||
      this.filtersForm.get("fechaFin").value ||
      this.filtersForm.get("userName").value ||
      this.filtersForm.get("csvType").value ||
      this.filtersForm.get("minRec").value ||
      this.filtersForm.get("maxRec").value ||
      this.filtersForm.get("insertedUpdatedOrInvalid").value
      ? true
      : false;
  }

  public filtrar() {
    this.validDates();

    if (this.filtersForm.valid) {
      this.applyFilters();
    } else {
      if (Object.keys(this.filtersForm.controls).some((key) => this.filtersForm.get(key).hasError('pattern'))) {
        this.showError = true;
        this.mensajes.push({
          class: "error",
          message: "csvLogs.errors.recFormat",
        });
      }
    }
  }

  public resetForm() {
    this.filtersForm.reset();
    this.filtersForm.get("insertedUpdatedOrInvalid").setValue("insercion");
  }

  public applyFilters() {
    this.currentPage = 0;
    this.dropdownSection = -1;
    this._adminContext.csvLogsFilters = {
      fechaInicio: this.filtersForm.get("fechaInicio").value
        ? this.utilsService.parseGMTtoYYYYMMDD(
            this.filtersForm.get("fechaInicio").value
          )
        : "",
      fechaFin: this.filtersForm.get("fechaFin").value
        ? this.utilsService.parseGMTtoYYYYMMDD(
            this.filtersForm.get("fechaFin").value
          )
        : "",
      userName_Exacto: this.filtersForm.get("userName").value
        ? this.filtersForm.get("userName").value
        : "",
      tipoRegistroCsvId: this.filtersForm.get("insertedUpdatedOrInvalid").value
        ? this.filtersForm.get("insertedUpdatedOrInvalid").value.id
        : "",
      tipoImportCsvId: this.filtersForm.get("csvType").value
        ? this.filtersForm.get("csvType").value
        : "",
      nRegistrosMin: this.filtersForm.get("minRec").value
        ? this.filtersForm.get("minRec").value
        : "",
      nRegistrosMax: this.filtersForm.get("maxRec").value
        ? this.filtersForm.get("maxRec").value
        : "",
      numPagina: this.currentPage,
      tamPagina: this.itemsPerPage,
    };

    this.getCsvLogs();
  }

  public getCsvLogs() {
    if (this._adminContext.csvLogsFilters) {
      this._filters = this._adminContext.csvLogsFilters;
    } else {
      this.applyFilters();
    }
    this._spinnerService.showSpinner();
    this.toCloseSpinner += 1;
    this._adminService
      .getCsvLogs(this._filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        this.totalItems = resp.paginacionMeta.totalCount;
        this.csvLogs = resp.lista;
      }, (error) => {
          this.showError = true;
          this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        }
      );
  }

  
  public downloadCsvLog(fileName: string | null, csvTypeId: number | null) {
    const filters = {
      fileName: fileName,
      tipoImportCsvId: csvTypeId,
    };

    this._spinnerService.showSpinner();
    this._adminService.downloadCsvLog(filters).toPromise().finally(() => {
      this._spinnerService.hideSpinner();
    }).then((resp) => {
        const downloadLink = document.createElement('a');
        downloadLink.href = 'data:text/csv;base64,' + resp.base64Archivo;
        downloadLink.download = resp.nombreArchivo;
        downloadLink.click();
      },
      (error) => {
        this.showError = true;
        this.mensajes.push({ class: 'error', message: 'global.error.file' });
      }
    );
  }

  public getCsvType(id: number | null) {
    const type = this.csvTypes.find((el) => el.id === id);
    return type?.des;
  }

  public showSection(i: number, fileName: string, csvTypeId: number) {
    this.dropdownSection = this.dropdownSection === i ? -1 : i;
    this.pestanaActiva[i] =
      this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
    this.csvFileName = fileName;
    this.csvTypeId = csvTypeId; // desTipoImportCsv no sirve ya que "Envío" podría referirse a varios tipos realmente
  }

  public showRegistros(i: number) {
    this.pestanaActiva[i] = 1;
  }

  public pageChange(page) {
    this.dropdownSection = -1;
    this._adminContext.csvLogsFilters.numPagina = this.currentPage = page - 1;
    this.getCsvLogs();
  }

  public itemsPerPageChange(items) {
    this.dropdownSection = -1;
    this._adminContext.csvLogsFilters.numPagina = this.currentPage = 0;
    this._adminContext.csvLogsFilters.tamPagina = this.itemsPerPage = items;
    this.getCsvLogs();
  }

  public getIcon(prop: string) {
    let iconClass = "fa fa-sort";
    if (
      this._filters &&
      this._filters.orderItems &&
      this._filters.orderItems[0].orderProperty === prop
    ) {
      iconClass =
        this._filters.orderItems[0].orderByDescending === true
          ? "fa fa-sort-down"
          : "fa fa-sort-up";
    }
    return iconClass;
  }

  public toOrderBy(columnFilter, idColumn) {
    this.columnId = idColumn;
    if (this.csvLogs && this.csvLogs.length > 0) {
      if (this._adminContext.csvLogsFilters) {
        this._filters = this._adminContext.csvLogsFilters;
        if (!this.orderBy || this.orderBy.includes("DESC")) {
          this.orderBy = "ASC" + idColumn;
          this._filters.orderItems = [
            {
              orderProperty: columnFilter,
              orderByDescending: false,
            },
          ];
        } else if (this.orderBy.includes("ASC")) {
          this.orderBy = "DESC" + idColumn;
          this._filters.orderItems = [
            {
              orderProperty: columnFilter,
              orderByDescending: true,
            },
          ];
        }
        this.getCsvLogs();
      }
    }
  }

  public trackByCsvLogId(index: number, csvLog: { logCsvId: number }): number {
    return csvLog.logCsvId;
  }
}
